define('viewmodels/ActionTracker/ActionItemDashboard',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils'], function (ko, router, app, appsecurity, navigation, system, logger, utils) {
    var ActionItemDashboardVM = {
        title: ko.observable("Action Tracker Dashboard"),
        attached: attached,
        activate: activate,
        appsecurity: appsecurity,
        router: router,
        logger: logger,
        utils: utils,
        SurveyTypeDrpDwnList: ko.observableArray(),
        RolesDrpDwnList: ko.observableArray(),   // added for role drop down in dashboard page
        RoleValue: ko.observable(),
        ActionItemRoleChange: ActionItemRoleChange,
        ResponseMoveArray: ko.observableArray([]),
        NewAssignmentClick: NewAssignmentClick,
        WIPClick: WIPClick,
        CompletedFlag: ko.observable(),
        AssignedCount: ko.observable(0),
        WorkInProgressCount: ko.observable(0),
        CompletedCount: ko.observable(0),
        NotificationsCount: ko.observable(0),
        Notificationlist: ko.observableArray(),
        NewAssignmentlist: ko.observableArray(),
        WorkInProgresslist: ko.observableArray(),
        CompletedList: ko.observableArray(),
        Completedlist: ko.observableArray(),
        NotificationList: ko.observableArray(),
        IsComposeFlag: ko.observableArray()
    };
    return ActionItemDashboardVM;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | activate() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            var url = window.location.pathname;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (filename == "ActionItemDetails") {
                window.location.pathname = window.location.pathname.replace('ActionItemDetails', 'ActionItemDashboard')
            }

            RaTableObj = $('#tblNewAssignment').DataTable({
                "iDisplayLength": 5,
                responsive: true,
                "aoColumnDefs": [{
                    "aTargets": [1],
                    "bSearchable": false
                }]
            });



            NotificationTblObj = $('#tblNotification').DataTable();
            CompletedTblObj = $('#tblCompleted').DataTable();
            $('#divTables').hide();
            $('#loadingImgforDashboard').show();
            GetAllUserRole();
            
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | attached() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    };

    function GetAllUserRole() {
        try {
            $.ajax({
                url: "/api/ActionPlan/GetAllUserRoleDashboard",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | source: GetAllUserRole() in ActionItemDashboard.js';
            logger.logMessage(msg)
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                ActionItemDashboardVM.RolesDrpDwnList([]);
                if (jsonResult != null) {
                    var mappedRole = $.map(jsonResult, function (result) {
                        return new RoleModel(result);
                    });
                    ActionItemDashboardVM.RolesDrpDwnList(mappedRole);

                    //GetActionItemDash();

                }
                else {
                    ActionItemDashboardVM.RolesDrpDwnList([]);
                }
            }
            catch (e) {
                var msg = 'exception' + e + ' | source: ajaxSucess() in GetAllUserRole() in ActionItemDashboard.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUserRole() method in ActionItemDashboard.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUserRole() method in ActionItemDashboard.js';
                logger.logMessage(msg);
            }
        }

    }

    function ActionItemRoleChange(data, event) {
        try {
            if (ActionItemDashboardVM.RolesDrpDwnList().length != 0) {
                ActionItemDashboardVM.RoleValue($("#RoleDrpDown").val());
                if (ActionItemDashboardVM.ResponseMoveArray() != undefined && ActionItemDashboardVM.ResponseMoveArray().length != 0) {
                    if (ActionItemDashboardVM.RolesDrpDwnList()[0].RoleId() != ActionItemDashboardVM.ResponseMoveArray().RoleId() && ActionItemDashboardVM.ResponseMoveArray().RoleId() != "") {
                        ActionItemDashboardVM.RoleValue(ActionItemDashboardVM.ResponseMoveArray().RoleId());
                        $("#RoleDrpDown").val(ActionItemDashboardVM.ResponseMoveArray().RoleId())
                        ActionItemDashboardVM.ResponseMoveArray([]);
                    }
                }
                if (ActionItemDashboardVM.RolesDrpDwnList() != '') {
                    LoadActionItemsDashboard();
                }
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | surveydropdownevent() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    }

    function LoadActionItemsDashboard() {
        try {
            GetAllNewAssignment().then(function () {
                GetAllWorkInProgress().then(function () {
                    GetAllCompleted();
                })
            })

        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | LoadActionItemsDashboard() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    }


    //----------------------------------------------------------------Logic to Populate all 4 Grids on Dashboard Starts Here--------------------------------------------------------------------------------

    // for getting all the New Assignment 
    function GetAllNewAssignment() {
        try {

            return $.ajax({
                url: "/api/ActionPlan/GetAllNewAssignment?roleid=" + ActionItemDashboardVM.RoleValue(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | GetAllNewAssignment() in ActionItemDashboard.js'
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {
                    ActionItemDashboardVM.appsecurity.WriteAccess('true');
                    ActionItemDashboardVM.AssignedCount(jsonResult.length);
                    ActionItemDashboardVM.NewAssignmentlist([]);
                    RaTableObj.destroy();
                    $('#tblNewAssignment tbody tr').remove();
                    var mappedQuestion = $.map(jsonResult, function (result) {
                        var QuesObj = new GenericModel(result);
                        return QuesObj;
                    })
                    ActionItemDashboardVM.NewAssignmentlist(mappedQuestion);
                    RaTableObj = $('#tblNewAssignment').DataTable();
                }
                else {
                    $('#loadingImgforDashboard').hide();
                    $('#tblNewAssignment').DataTable().clear().draw();
                    ActionItemDashboardVM.AssignedCount(0);
                    console.log('An error occurred while fetching the New Assignments queue.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllNewAssignment() in ActionItemDashboard.js'
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                $('#loadingImgforDashboard').hide();
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllNewAssignment() method in ActionItemDash.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllNewAssignment() method in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }
    }


    // for getting all the notification
    function GetAllNotification() {
        try {

            $.ajax({
                url: "/api/ActionPlan/GetAllNotification",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | GetAllNotification() in ActionItemDash.js'
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {
                    ActionItemDashboardVM.NotificationsCount(jsonResult.length);
                    ActionItemDashboardVM.NotificationList([]);
                    NotificationTblObj.destroy();
                    $('#tblNotification tbody tr').remove();
                    var mappedNotification = $.map(jsonResult, function (result) {
                        var Notificationbj = new GenericModel(result);
                        return Notificationbj;
                    })
                    ActionItemDashboardVM.NotificationList(mappedNotification);
                    NotificationTblObj = $('#tblNotification').DataTable();
                }
                else {
                    $('#loadingImgforDashboard').hide();
                    logger.logError('An error occurred while fetching the Notifications queue.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
                }


            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllNotification() in ActionItemDash.js'
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                $('#loadingImgforDashboard').hide();
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllNotification() method in ActionItemDash.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllNotification() method in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }
    }


    // for getting all the work in progress items
    function GetAllWorkInProgress() {
        try {
            return $.ajax({
                url: "/api/ActionPlan/GetAllWorkInProgress?roleid=" + ActionItemDashboardVM.RoleValue(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | GetAllWorkInProgress() in ActionItemDash.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {
                    ActionItemDashboardVM.appsecurity.WriteAccess('true');
                    ActionItemDashboardVM.WorkInProgressCount(jsonResult.length);
                    ActionItemDashboardVM.WorkInProgresslist([]);
                    var WIPTableObj = $('#tblWorkInProgress').DataTable();
                    $('#tblWorkInProgress tbody tr').remove();
                    WIPTableObj.destroy();
                    $('#tblWorkInProgress tbody tr').remove();
                    var mappedQuestion = $.map(jsonResult, function (result) {
                        var QuesObj = new GenericModel(result);
                        return QuesObj;
                    })
                    ActionItemDashboardVM.WorkInProgresslist(mappedQuestion);
                    WIPTableObj = $('#tblWorkInProgress').DataTable();
                }
                else {
                    $('#loadingImgforDashboard').hide();
                    $('#tblWorkInProgress').DataTable().clear().draw();
                    ActionItemDashboardVM.WorkInProgressCount(0);
                    console.log('An error occurred while fetching the Work In Progress queue.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllWorkInProgress() in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                $('#loadingImgforDashboard').hide();
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllWorkInProgress() method in ActionItemDash.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllWorkInProgress() method in ActionItemDashboard.js';
                logger.logMessage(msg);
            }
        }
    }



    function NewAssignmentClick(data, event) {
        try {
            var ActionItemID = data.ActionItemId();
            var Flag = data.Flag();

            var AssignedDate = data.AssignedDate();
            app.showMessage('Do you want to move selected Action Item to your Work In Progress list?', 'Move to Next Level', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-exchange text-default' })
                    .then(function (option) {
                        if (option === 'Confirm') {

                            MoveActionItemToWorkInProgress(ActionItemID, Flag);
                        }
                    });
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | NewAssignmentClick() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    }

    function MoveActionItemToWorkInProgress(ActionItemID, Flag) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/ActionPlan/MoveSurveyToWorkInProgress?ActionItemID=" + ActionItemID + "&Atype=" + Flag,
                headers: headers,
                type: "Post",
                async: false
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | ajax call in MoveSurveyToWorkInProgress() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 1) {

                    for (i = 0 ; i < ActionItemDashboardVM.NewAssignmentlist().length ; i++) {
                        if (ActionItemDashboardVM.NewAssignmentlist()[i].ActionItemId() == ActionItemID) {

                            RaTableObj.row(i).remove().draw(false);
                            ActionItemDashboardVM.NewAssignmentlist.splice(i, 1);
                        }
                    }
                    GetAllWorkInProgress();
                    logger.logSuccess('Action Item has been moved to the Working queue successfully.', 'Success', system.getModuleId(ActionItemDashboardVM), true);
                    ActionItemDashboardVM.WorkInProgressCount(ActionItemDashboardVM.WorkInProgressCount() + 1);
                    ActionItemDashboardVM.AssignedCount(ActionItemDashboardVM.AssignedCount() - 1);
                }
                else if (jsonResult == 0) {
                    logger.logWarning('The Survey that you are trying to move has already been picked by another user.', 'Success', system.getModuleId(ActionItemDashboardVM), true)
                    GetAllNewAssignment(SType);
                }

                else {
                    logger.logError('An error occurred while moving the Action Item to Work in Progress queue.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxSuccess in MoveSurveyToWorkInProgress() in ActionItemDashboard.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            router.navigate("configuration", true);

                    })
                }
                else {
                    var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in ActionItemDashboard.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in ActionItemDashboard.js';
                logger.logMessage(msg);
            }
        }
    }


    function WIPClick(data, event) {
        try {
            var ActionItemid = data.ActionItemId();

            var Status = "";
            if (event.currentTarget.parentNode.parentNode.parentNode.parentNode.id == "tblCompleted") {
                Status = "Completed";
                ActionItemDashboardVM.CompletedFlag(true);
            }
            else {
                Status = "InProgress";
                ActionItemDashboardVM.CompletedFlag(false);
            }
            var SelectedRoleName = document.getElementById('RoleDrpDown').options[document.getElementById('RoleDrpDown').selectedIndex].innerText;
            if (data.Flag() == "ACTION ITEM") {
                ActionItemDashboardVM.appsecurity.ActionFlagType("Item");
                ActionItemDashboardVM.ResponseMoveArray(new ResponseMoveModel({ ActionItemId: ActionItemid, ActionItemNumber: data.AIM_TITLE_UID(), IsFromDashboard: false, RoleName: SelectedRoleName, ActionItemStatus: Status, RoleId: ActionItemDashboardVM.RoleValue(), CompletedFlag: ActionItemDashboardVM.CompletedFlag(), IsComposeFlag: ko.observable(0) }));
                router.navigate("#ActionTracker/ActionItemDetails", true);
            }
            else {
                ActionItemDashboardVM.appsecurity.ActionPageType("PlanDashboard");
                ActionItemDashboardVM.appsecurity.ActionFlagType("Plan");
                ActionItemDashboardVM.ResponseMoveArray(new ResponseMoveModel({ ActionItemId: ActionItemid, ActionItemNumber: data.AIM_TITLE_UID(), IsFromDashboard: true, RoleId: ActionItemDashboardVM.RoleValue(), CompletedFlag: ActionItemDashboardVM.CompletedFlag()}));
                router.navigate("#ActionTracker/ActionPlanDetails", true);
            }
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | WIPClick() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    }

    // for getting all the completed items
    function GetAllCompleted() {
        try {

            return $.ajax({
                url: "/api/ActionPlan/GetAllCompleted?RoleId=" + ActionItemDashboardVM.RoleValue(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source | ajax call in GetAllCompleted() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null) {
                    ActionItemDashboardVM.appsecurity.WriteAccess('true');
                    ActionItemDashboardVM.CompletedCount(jsonResult.length);
                    ActionItemDashboardVM.CompletedList([]);

                    $('#tblCompleted tbody tr').remove();
                    CompletedTblObj.destroy();
                    $('#tblCompleted tbody tr').remove();
                    var mappedQuestion = $.map(jsonResult, function (result) {
                        var QuesObj = new GenericModel(result);
                        return QuesObj;
                    })
                    ActionItemDashboardVM.CompletedList(mappedQuestion);
                    CompletedTblObj = $('#tblCompleted').DataTable();
                    $('#divTables').show();
                    $('#loadingImgforDashboard').hide();
                }
                else {
                    $('#loadingImgforDashboard').hide();
                    $('#tblCompleted').DataTable().clear().draw();
                    ActionItemDashboardVM.CompletedCount(0);
                    $('#divTables').show();
                    $('#loadingImgforDashboard').hide();
                    console.log('An error occurred while fetching the Completed Assignments queue.', 'Error', system.getModuleId(ActionItemDashboardVM), true);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllCompleted() in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                $('#loadingImgforDashboard').hide();
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllCompleted() method in ActionItemDash.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllCompleted() method in ActionItemDash.js';
                logger.logMessage(msg);
            }
        }

    }
    //----------------------------------------------------------------Logic to Populate all 4 Grids on Dashboard Ends Here--------------------------------------------------------------------------------


    //----------------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------------
    function RoleModel(item) {
        try {
            var self = this;
            self.RoleId = ko.observable(item.RoleId);
            self.RoleName = ko.observable($('<div/>').html(item.RoleName).text());
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: RoleModel() in ActionItemDashboard.js';
            logger.logMessage(msg);
        }
    }

    function GenericModel(item) {
        try {
            var self = this;
            self.ActionItemId = ko.observable(item.ActionItemId);
            self.AIM_TITLE_UID = ko.observable(item.AIM_TITLE_UID);
            self.ActionItemTitle = ko.observable(item.ActionItemTitle);
            self.NotificationDate = ko.observable(item.NotificationDate);
            self.NotificationMessage = ko.observable(item.NotificationMessage);
            self.NotificationDate = ko.observable(item.NotificationDate);
            self.NotificationPriority = ko.observable(item.NotificationPriority);
            self.NotificationSender = ko.observable(item.NotificationSender);
            self.AssignedDate = ko.observable($('<div/>').html(item.AssignedDate).text());
            self.Flag = ko.observable($('<div/>').html(item.Flag).text());
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: GenericModel() in ActionItemDash.js';
            logger.logMessage(msg);
        }
    }

    function ResponseMoveModel(item) {
        try {
            var self = this;
            self.ActionItemId = ko.observable(item.ActionItemId);
            self.ActionItemNumber = ko.observable(item.ActionItemNumber);
            self.RoleName = ko.observable(item.RoleName);
            self.RoleId = ko.observable(item.RoleId);
            self.ActionItemStatus = ko.observable(item.ActionItemStatus);
            self.CompletedFlag = ko.observable(item.CompletedFlag);
            self.IsComposeFlag = ko.observable(0);
            self.IsFromDashboard = ko.observable(true);
        }
        catch (e) {
            var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in ActionItemDash.js';
            logger.logMessage(msg);
        }
    }    
    //----------------------------------------------------------------------Model Definition Ends Here----------------------------------------------------------------------------------
});
